import React, { useEffect, useState } from 'react';
import PaywallDialog from '@/components/dialogs/PaywallDialog';

/** Listens for the global `paywall:open` window event (emitted by the
 *  axios interceptor in /lib/api.js) and renders the modal once per
 *  trigger. Lives at App level so any axios 402 anywhere in the tree
 *  can summon it without prop drilling. */
export function PaywallProvider() {
  const [open, setOpen] = useState(false);
  const [paywall, setPaywall] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      setPaywall(e.detail);
      setOpen(true);
    };
    window.addEventListener('paywall:open', handler);
    return () => window.removeEventListener('paywall:open', handler);
  }, []);

  return <PaywallDialog open={open} paywall={paywall} onClose={() => setOpen(false)} />;
}
